import { createSelector } from '@reduxjs/toolkit'

import { AuthState } from '@/ducks/auth/slice/auth.slice'

export const selectAuth = (state: { auth: AuthState }) => state.auth

export const selectToken = createSelector(selectAuth, auth => {
  return auth.token
})
export const selectIsAuthed = createSelector(selectAuth, auth => !!auth.token)
